import React from 'react';
import { Typography } from '../wag-react/components/Typography';
import { LI } from '../wag-react/core-components/li';
import { Strong } from '../wag-react/core-components/strong';
import { UL } from '../wag-react/core-components/ul';
export const WELLNESS_ADD_ON_DETAILS = [{
  name: 'Flea, tick, & heartworm meds',
  price: 19.95,
  description: <>
        <Typography>
          Parasites are a threat to your pet throughout the year. Despite the common belief that
          fleas, ticks and mosquitoes are only active in warmer months, these pests can cause
          big problems for your pet at any time during the year, including transmitting diseases
          to them.
        </Typography>

        <Typography>
          The best way to protect against them is year-round flea, tick and heartworm disease
          protection.
        </Typography>

        <Typography>
          <Strong>
            Flea, tick and heartworm coverage pays for:
          </Strong>
        </Typography>

        <Typography>
          ANY flea and tick medication, including Nexgard, Bravecto, Trifexis, Sentinel,
          Frontline, Capstar, Simparica & K9 Advantix.
        </Typography>

        <Typography>
          ANY heartworm medication, including Advantage Multi, Heartgard, Interceptor,
          Iverheart, Sentinel, Trifexis & Tri-Heart.
        </Typography>
      </>
}, {
  name: 'Grooming',
  price: 19.95,
  description: <>
        <Typography>
          <Strong>
            Coverage pays for:
          </Strong>
        </Typography>

        <Typography>
          {'Your pet\'s wash & blow-dry, haircut, and nail trims when carried out by your'}
          vet or specialist pet groomer (including mobile groomers).
        </Typography>

        <Typography>
          The maximum this plan will pay for is
          {' '}
          <Strong>
            $300
          </Strong>
          {' '}
          in a 12-month period.
        </Typography>

        <Typography>
          Not offered with Wag! Premium subscription.
        </Typography>
      </>
}, {
  name: 'Dental cleaning',
  price: 29.95,
  description: <>
        <Typography>
          Dental cleaning is carried out by your vet and is crucial to help keep your
          pet risk-free from periodontal disease, which can be very painful and expensive
          to treat.
        </Typography>

        <UL>
          <LI>
            <Typography>
              Pre-Anesthetic Blood Test/ECG
            </Typography>
          </LI>

          <LI>
            <Typography>
              Anesthesia
            </Typography>
          </LI>

          <LI>
            <Typography>
              Extractions
            </Typography>
          </LI>

          <LI>
            <Typography>
              Dental cleaning/polishing
            </Typography>
          </LI>

          <LI>
            <Typography>
              Painkillers given during pre/post-surgery
            </Typography>
          </LI>
        </UL>

        <Typography>
          The maximum this plan will pay for is
          {' '}
          <Strong>
            $400
          </Strong>
          {' '}
          in a 12-month period.
        </Typography>
      </>
}, {
  name: 'Spay / neuter',
  price: 29.95,
  description: <>
        <Typography>
          <Strong>
            Spay / Neuter coverage pays for:
          </Strong>
        </Typography>

        <UL>
          <LI>
            <Typography>
              Pre-Anesthetic Blood Test/ECG
            </Typography>
          </LI>

          <LI>
            <Typography>
              Anesthesia
            </Typography>
          </LI>

          <LI>
            <Typography>
              Surgery
            </Typography>
          </LI>

          <LI>
            <Typography>
              Painkillers given during pre/post-surgery
            </Typography>
          </LI>
        </UL>

        <Typography>
          The maximum this plan will pay for is
          {' '}
          <Strong>
            $400.
          </Strong>
        </Typography>
      </>
}];